module.exports = {"roverBaseUrl":"https://roverdev01.samsclub.com","apiKeyValidationRegex":"^[a-zA-Z0-9]*$"}


//////////////////
// WEBPACK FOOTER
// ./src/config/dev01.json
// module id = 527
// module chunks = 5